import jQuery from 'jquery';
import 'slick-carousel';
import initAccountMenu from '../components/account-menu';
// import StickySidebar from 'sticky-sidebar';
var ElementQueries = require('css-element-queries/src/ElementQueries');
var Stickyfill = require('stickyfilljs');

export default {
    init() {
        ElementQueries.listen();
        // JavaScript to be fired on all pages
        formatArticleContent();
        // analytics();
        // gestionFormulaireNewsletter();
        rendreArticlesClickable();
        stickySidebars();

        handleMenus();
        initAccountMenu();
        giveFocusToSearchField();
        // activeHeaderBtn();
        doSlickCarrousels();
        initQuantityStepper();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};

/* function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	}
} */

// var handleResizeDebounced = debounce(function() {
// 	// All the taxing stuff you do
//     handleMenuSize();
// }, 250);

// var handleMenuSize = (init = false) => {
//     console.log('Handling resize')
//     let elem = jQuery('#menu-menu-principal');
//     jQuery('.sub-menu', elem).css({ top : elem.height() });
//     if(init) {
//         jQuery('.current-menu-ancestor .sub-menu', elem).css({ visibility : 'visible' });
//     }
//     // , visibility: 'visible'
// }


function handleMenus(){
    // document.addEventListener("touchstart", function(e) {
    //     console.log(e.defaultPrevented);  // will be false
    //     e.preventDefault();   // does nothing since the listener is passive
    //     console.log(e.defaultPrevented);  // still false
    // }, Modernizr.passiveeventlisteners ? {passive: true} : false);
    // console.log('Handle menus')

    minifiedStickyMenu();
    // toggleMobileMenu();
    handleCurrentSubmenu();
    // addCategoryLinkInSubmenus();
    handleCaretOnDesktopMenu();
    handleMobileSubmenus();

    // handleMenuSize(true);
    // window.addEventListener("resize", handleResizeDebounced);
}

function doSlickCarrousels(){
    jQuery(function(){
        doSlickCarrousel('.carousel-partenaire');
    });
}

function doSlickCarrousel(selector){
    jQuery(selector).css('width', jQuery(selector).closest('.container').width());
    setTimeout(() => {
        jQuery(selector).slick({
            // normal options...
            infinite: true,
            adaptiveHeight: true,
            arrows: true,
            autoplay: true,
            dots: true,
            slidesToShow: 3,
            autoplaySpeed: 4000,
            respondTo: 'slider',
            // the magic
            responsive: [{
              breakpoint: 990,
              settings: {
                slidesToShow: 3,
                dots: true,
                infinite: true,
              },
            }, {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                dots: true,
              },
            }, {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                dots: true,
              },
            }],
        });
    }, 50)
    
}

function stickySidebars() {
    // console.log('Build stickies');
    var elements = $('.sticky');
    Stickyfill.add(elements);
    // $("#secondary").affix({
    //     offset: {
    //       top: 60
    //     }
    // });
    // new StickySidebar('#secondary', {
    //   topSpacing: 0,
    //   bottomSpacing: 20,
    //   containerSelector: '#inner-layout-wrapper',
    //   innerWrapperSelector: '.sidebar__inner',
    // });
}

function rendreArticlesClickable() {

    jQuery('body').on('click', '.row.post-sidebar', function () {
        // console.log('Row post', $('a.read-more', this).attr('href'));
        // if (e.target !== this)
        //   return;

        location.href = $('a.read-more', this).attr('href');
    });

    // jQuery('.post.in-grid').on('click', function(e) {
    //   if (e.target !== this)
    //     return;

    //   location.href = $('.excerpt a', this).attr('href');
    // });

    // jQuery('.post.post-carre').on('click', function(e) {
    //   if (e.target !== this)
    //     return;

    //   location.href = $('.post-info a', this).attr('href');
    // });
}

// function gestionFormulaireNewsletter() {
//     console.log('Gestion newsletter');

//     // Sidebar Newsletter form
//     $('body').on('submit', '.wd-mautic-sidebar-wrapper', function (event) {
//         console.log('Envoyer le formulaire');

//         event.preventDefault();
//         jQuery('.wd-mautic-sidebar-btn').html('<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');

//         // a reference to the form to get used inside ajax callback
//         var form = this;

//         $.ajax({
//             url: $(form).attr('action'),
//             type: "POST",
//             data: $(form).serialize(),
//             success: function (response) {
//                 console.log("inscription ok", response)
//                 if ($('#mauticform_inscriptionnewsletterpetitnouveau_email').hasClass('mauticform-has-error') === true) {
//                     $('.wd-mautic-sidebar-btn').html('<i class="fas fa-times"></i>');
//                     //$('.fa-times').fadeOut(4000).delay(800).$('.mauticform-button').html('<i class="fas fa-envelope"></i>').fadeIn(200);

//                     setTimeout(function () {
//                         document.querySelector('.wd-mautic-sidebar-btn').innerHTML = '<i class="fas fa-envelope"></i>';
//                         let errorMsg = document.querySelector('.wd-mautic-sidebar-errormsg');
//                         errorMsg.style.opacity = '0';
//                         errorMsg.addEventListener('transitionend', () => errorMsg.remove());
//                     }, 1800);

//                     console.log("error mautic")

//                 } else {

//                     $('.wd-mautic-sidebar-btn').html('<i class="fas fa-check"></i>');
//                 }


//             },
//         });

//         return false;
//     })

//     // Footer Newsletter form
//     // $('body').on('submit', '.wd-mautic-footer-wrapper', function (event) {
//     //     console.log('Envoyer le formulaire');

//     //     event.preventDefault();
//     //     jQuery('.wd-mautic-footer-btn').html('<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');

//     //     // a reference to the form to get used inside ajax callback
//     //     var form = this;

//     //     $.ajax({
//     //         url: $(form).attr('action'),
//     //         type: "POST",
//     //         data: $(form).serialize(),
//     //         success: function (response) {
//     //             console.log("inscription ok", response)
//     //             // class "mauticform-has-error" can't be added because of the ID (JS mautic)
//     //             if ($('#mauticform_inscriptionnewsletterpetitnouveau_email_wd_mautic_footer').hasClass('mauticform-has-error') === true) {
//     //                 $('.wd-mautic-footer-btn').html('<i class="fas fa-times"></i>');
//     //                 //$('.fa-times').fadeOut(4000).delay(800).$('.mauticform-button').html('<i class="fas fa-envelope"></i>').fadeIn(200);

//     //                 setTimeout(function () {
//     //                     document.querySelector('.wd-mautic-footer-btn').innerHTML = '<i class="fas fa-envelope"></i>';
//     //                     let errorMsg = document.querySelector('.wd-mautic-footer-errormsg');
//     //                     errorMsg.style.opacity = '0';
//     //                     errorMsg.addEventListener('transitionend', () => errorMsg.remove());
//     //                 }, 1800);

//     //                 console.log("error footer mautic")

//     //             } else {

//     //                 $('.wd-mautic-footer-btn').html('<i class="fas fa-check"></i>');
//     //             }


//     //         },
//     //     });

//     //     return false;
//     // })
// }



const generateNewParagraphe = (part1, part2) => {
    return `<span class="lettrine">${part1}</span>${part2}`;
}

function formatArticleContent() {
    $('.texte_lettrine_2col_par').each(function () {
        let paragrapheWithLettrine = $(this).html();
        console.log(paragrapheWithLettrine);
        let lettrine = paragrapheWithLettrine.substr(0, 1);
        let reste = paragrapheWithLettrine.substr(1);
        $(this).html(generateNewParagraphe(lettrine, reste));
    })
}

function minifiedStickyMenu() {
    let initHeight = jQuery('header#header-menu').height();
    let isSticky = false;
    let passedHeader = false;
    var scrollTop = 0;
    var pageWidth = 0;
    document.addEventListener('scroll resize', function () {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        pageWidth = window.outerWidth;
        if (scrollTop > (initHeight - 80)) {
            if(!isSticky) {
                console.log('Adding sticky-menu class');
                jQuery('body').addClass('sticky-menu');
                isSticky = true;
            }
        } else {
            if(isSticky) {
                console.log('Removing sticky-menu class');
                isSticky = false;
                jQuery('body').removeClass('sticky-menu');
            }
        }

        if(pageWidth <= 740 && scrollTop > (initHeight)) {
            if(!passedHeader) {
                console.log('Adding scrolled class');
                jQuery('body').addClass('scrolled');
                passedHeader = true;
            }
        } else {
            if(passedHeader) {
                console.log('Removing scrolled class');
                passedHeader = false;
                jQuery('body').removeClass('scrolled');
            }
        }
    }, true /*Capture event*/);
    
    // $(window).scroll(function () {
    //     scrollTop = $(window).scrollTop();
    //     // $('.counter').html(scrollTop);

    //     if (scrollTop >= 100) {
    //         // $('#header-menu').addClass('sticky-menu');
    //         $('body').addClass('sticky-header');
    //         // handleMenuSize()
    //     } else if (scrollTop < 100) {
    //         // $('#header-menu').removeClass('sticky-menu');
    //         $('#content').removeClass('sticky-header');
    //         // handleMenuSize()
    //     }

    // });
}
/*
function toggleMobileMenu() {
    let counter = 0;
    let topMenu,
        mainSubMenu,
        item,
        menu,
        submenu;

    topMenu = $('.header-menu-principal .nav-wrapper')
    mainSubMenu = $('#menu-menu-principal').find('.sub-menu');
    $("nav .menu-item-has-children").each(function(){
        menu = $('.sub-menu', this);
        item = menu.prev();
        item.append('<span class="wd-mobile-caret-icon"><i class="fas fa-caret-right"></i></span>');
        if (counter <= 0) {
            mainSubMenu.append('<a href="#" class="wd-mobile-back"><i class="fas fa-caret-left"></i> Retour</a>');
            counter++;
        }
    });

    // handle submenu
    $('body').on('click', '.wd-mobile-menu-item-has-children > a', function (e) {
        e.preventDefault();
        submenu = $(e.target).parent().find('.sub-menu');
        submenu.toggleClass('wd-mobile-submenu-open');
        topMenu.toggleClass('is-submenu-open');
    });

    $('body').on('click', '.wd-mobile-back', function (e) {
        e.preventDefault();
        let target = $(e.target).parent();
        target.toggleClass('wd-mobile-submenu-open');
        topMenu.toggleClass('is-submenu-open');
    });

    $('body').on('click', '.wd-toggle-menu', function (e) {
        e.preventDefault();
        $(this).toggleClass('wd-mobile-menu-open');
        $('#menu-menu-principal').toggleClass('wd-mobile-menu-open');
        $('.nav-wrapper').toggleClass('wd-mobile-menu-open');
        $('.menu-item-has-children').toggleClass('wd-mobile-menu-item-has-children');
    });

    $('body').on('click', '.wd-close-mobile-menu-icon', function (e) {
        e.preventDefault();
        $(this).toggleClass('wd-mobile-menu-open');
        $('#menu-menu-principal').toggleClass('wd-mobile-menu-open');
        $('.nav-wrapper').toggleClass('wd-mobile-menu-open');
        $('.menu-item-has-children').toggleClass('wd-mobile-menu-item-has-children');
        topMenu.removeClass('is-submenu-open');
        if ($('.sub-menu').hasClass('wd-mobile-submenu-open')) {
            $('.sub-menu').removeClass('wd-mobile-submenu-open');
        }
    });
}*/

function handleCurrentSubmenu() {
    let currentSubMenu = $('.current-menu-item').find('.sub-menu');

    // add class to current submenu
    if ($('.menu-item-has-children').hasClass('current-menu-item')) {
        $(currentSubMenu).addClass('wd-current-submenu');
        
    } else if ($('.menu-item-has-children').hasClass('current-menu-parent')) {
        $('.current-menu-parent').find('.sub-menu').addClass('wd-current-submenu');
    }

    if ($('.menu-item').hasClass('current-menu-item')) {
        $('.current-menu-item').addClass('wd-current-page');
    } 
}

/*function addCategoryLinkInSubmenus() { 
    // add link of main category in submenu
    if (!$('.nav-wrapper').hasClass('.wd-mobile-menu-ready')) {
      
        $("nav .menu-item-has-children").each(function(){
  
            let submenu = $('.sub-menu', this);
            let item = submenu.prev();
  
            let clonedLinkElement = item.clone();
            
            let wrapped = "<li class='" + item.parent().attr('class').replace(
              /menu-item-has-children|wd-current-page|wd-mobile-menu-item-has-children/gi,
              function() { return 'wd-submenu-category'; }
            ) + "'>" + clonedLinkElement.get(0).outerHTML + "</li>";
            
            submenu.prepend(wrapped);
  
  
        });
        $('.nav-wrapper').addClass('wd-mobile-menu-ready');  
    }
}*/

function handleCaretOnDesktopMenu() {
    $('.menu-item-has-children').each(function () {
        var $link = $(this).children('a').first();
        if ($link.length && !$link.children('.wd-desktop-caret').length) {
            $link.append('<i class="fas fa-angle-down wd-desktop-caret" aria-hidden="true"></i>');
        }
    });
}

function handleMobileSubmenus() {
    var $source = $('.site-main-menu');
    if (!$source.length) return;

    // Keep the mobile navigation outside the header's stacking contexts, but
    // never duplicate DOM ids from the desktop navigation.
    $('.wd-mobile-panel, .wd-mobile-overlay').remove();
    var $panel = $source.clone();
    $panel.find('[id]').removeAttr('id');
    $panel
        .removeAttr('id')
        .removeClass('site-main-menu')
        .addClass('wd-mobile-panel')
        .attr({
            id: 'wd-mobile-panel',
            role: 'dialog',
            'aria-modal': 'true',
            'aria-label': 'Menu principal',
            'aria-hidden': 'true',
            inert: '',
        });
    $panel.find('.wd-desktop-caret, .wd-toggle-menu, .wd-close-mobile-menu-icon').remove();
    $panel.appendTo('body');

    var $navWrapper = $panel.find('.nav-wrapper').first();
    var $menuButton = $('.menu-btn[for="menu"]').first();
    var $menuToggle = $('#menu');
    var $overlay = $('<button type="button" class="wd-mobile-overlay" aria-label="Fermer le menu" tabindex="-1"></button>');
    var $panelHeader = $('<div class="wd-mobile-panel-header"></div>');
    var $brand = $('.col-logo > a').first().clone();
    var $closeButton = $(
        '<button type="button" class="wd-panel-close" aria-label="Fermer le menu">' +
            '<span class="wd-panel-close-label">Fermer</span>' +
            '<span class="wd-panel-close-icon" aria-hidden="true"></span>' +
        '</button>'
    );

    $brand
        .removeAttr('id')
        .addClass('wd-mobile-brand')
        .attr('aria-label', "Retour à l'accueil");
    $brand.find('[id]').removeAttr('id');
    $brand.find('img').each(function () {
        var $image = $(this);
        var eagerSource = $image.attr('data-lazy-src');
        if (eagerSource) $image.attr('src', eagerSource);
        $image
            // SmartCrop writes inline `cover` coordinates for the desktop
            // header. They crop publication marks when that image is cloned
            // into the shallower mobile masthead, so the drawer owns its own
            // uncropped image presentation.
            .removeClass('wpsmartcrop-image wpsmartcrop-rendered')
            .removeAttr('data-lazy-src data-lazy-srcset data-lazy-sizes data-smartcrop-focus style')
            .attr({ loading: 'eager', decoding: 'async', 'data-no-lazy': '1' });
    });

    $panelHeader.append($brand, $closeButton);
    $navWrapper.prepend($panelHeader);

    var isPublication = $('body').hasClass('network-publication');
    if (isPublication) {
        var publicationDescription = $('body').attr('data-publication-description') || "L'information professionnelle";
        var $intro = $(
            '<div class="wd-mobile-intro">' +
                '<p class="wd-mobile-kicker">L\'information professionnelle</p>' +
                '<p class="wd-mobile-intro-title"></p>' +
                '<form class="wd-mobile-search-form" role="search">' +
                    '<label class="sr-only" for="wd-mobile-search">Rechercher</label>' +
                    '<div class="wd-mobile-search-control">' +
                        '<input id="wd-mobile-search" type="search" name="_recherche" placeholder="Rechercher un sujet…" autocomplete="off">' +
                        '<button type="submit" aria-label="Lancer la recherche"><i class="fas fa-search" aria-hidden="true"></i></button>' +
                    '</div>' +
                '</form>' +
            '</div>'
        );
        $intro.find('.wd-mobile-intro-title').text(publicationDescription);
        $panelHeader.after($intro);

        var $primaryContainer = $panel.find('ul.menu-principal').first().parent();
        var $sectorContainer = $panel.find('ul.menu-secondaire').first().parent();
        if ($primaryContainer.length) {
            $primaryContainer
                .addClass('wd-mobile-primary-section')
                .prepend('<div class="wd-mobile-section-heading"><span>À la une</span><strong>Rubriques</strong></div>');
        }
        if ($sectorContainer.length) {
            $sectorContainer
                .addClass('wd-mobile-sector-section')
                .prepend('<div class="wd-mobile-section-heading"><span>Explorer</span><strong>Secteurs</strong></div>');
        }

        var $primaryLinks = $panel.find('ul.menu-principal > li > a');
        $primaryLinks.each(function () {
            var $link = $(this);
            if ($link.children('.electroniques-nav-icon, .dashicons, .menu-image').length) {
                $link.addClass('wd-mobile-nav-has-icon');
            }
        });
        if ($primaryLinks.filter('.wd-mobile-nav-has-icon').length) {
            $panel.addClass('wd-mobile-panel-has-primary-icons');
        }
        if (/(^|\.)(ria\.fr|culturesmarines\.fr)$/.test(window.location.hostname)) {
            $panel.addClass('wd-mobile-panel-reverse-primary-icons');
        }

        var $partnerLinks = $('.wd-account-btns > ul.partner-links > li > a.wd-account-btn');
        if ($partnerLinks.length) {
            // These destinations already exist as richer service actions below.
            $panel.find('ul.menu-principal > li.wd-menu-icon').remove();
            var $services = $('<div class="wd-mobile-services"><div class="wd-mobile-section-heading"><span>Découvrir</span><strong>Services</strong></div><div class="wd-mobile-service-actions"></div></div>');
            $partnerLinks.each(function () {
                $services.find('.wd-mobile-service-actions').append($(this).clone().removeAttr('id'));
            });
            $panel.find('nav.nav-primary').after($services);
        }

        var $account = $('<div class="wd-mobile-account"><span class="wd-mobile-account-label">Votre espace</span><div class="wd-mobile-account-actions"></div></div>');
        var $accountLinks = $('.wd-account-btns > ul.account-links > li > a.wd-account-btn');
        if (!$accountLinks.length) $accountLinks = $('.wd-account-btns > ul:not(.partner-links) > li > a.wd-account-btn');
        $accountLinks.each(function () {
            var $action = $(this).clone();
            $action.find('[id]').removeAttr('id');
            $account.find('.wd-mobile-account-actions').append($action);
        });
        var $riaAccount = $('.ria-account-menu').first();
        if ($riaAccount.length) {
            var $subscriber = $('<details class="ria-account-mobile"><summary><span></span><svg aria-hidden="true" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.7"><path d="m5 8 5 5 5-5"/></svg></summary></details>');
            $subscriber.find('summary span').text($riaAccount.find('.ria-account-label').text());
            $subscriber.append($riaAccount.find('.ria-account-list').clone());
            $account.addClass('wd-mobile-account--subscriber');
            $account.find('.wd-mobile-account-actions').prepend($subscriber);
        }
        if ($account.find('a').length) $navWrapper.append($account);

        $panel.on('submit', '.wd-mobile-search-form', function (event) {
            event.preventDefault();
            var query = $.trim($(this).find('input[type="search"]').val());
            if (query) window.location.href = window.location.origin + '/search/' + encodeURIComponent(query);
        });
    }

    $overlay.insertBefore($panel);

    var lastFocusedElement = null;
    var $drilldownStack = $('<div class="wd-mobile-drilldown-stack"></div>').appendTo($panel);

    function closeSubmenus() {
        $panel.find('.menu-item-has-children > a').attr('aria-expanded', 'false');
        $panel.find('.sub-menu')
            .removeClass('wd-drilldown-open')
            .attr('aria-hidden', 'true');
        $panel.removeClass('wd-submenu-active');
    }

    function setPanelState(isOpen, restoreFocus) {
        if (isOpen) {
            lastFocusedElement = document.activeElement;
            $panel
                .addClass('wd-panel-open')
                .removeAttr('inert')
                .attr('aria-hidden', 'false');
            $overlay.addClass('wd-overlay-open');
            $('html, body').addClass('wd-mobile-menu-active');
            $menuButton
                .attr({ 'aria-expanded': 'true', 'aria-label': 'Fermer le menu principal' });
            window.setTimeout(function () { $closeButton.trigger('focus'); }, 180);
        } else {
            closeSubmenus();
            $panel
                .removeClass('wd-panel-open')
                .attr({ 'aria-hidden': 'true', inert: '' });
            $overlay.removeClass('wd-overlay-open');
            $('html, body').removeClass('wd-mobile-menu-active');
            $menuButton
                .attr({ 'aria-expanded': 'false', 'aria-label': 'Ouvrir le menu principal' });
            if (restoreFocus && lastFocusedElement) $(lastFocusedElement).trigger('focus');
        }
    }

    function closePanel(restoreFocus) {
        $menuToggle.prop('checked', false);
        setPanelState(false, restoreFocus);
    }

    // The login plugin can bind before the mobile links are cloned. Forward
    // the mobile action to its original trigger after closing the drawer.
    $panel.on('click', '.ria-header-action--login.wlrp-popup-open', function (event) {
        event.preventDefault();
        closePanel(false);
        if (document.querySelector('.wd-lp-modal--open')) return;
        var href = $(this).attr('href');
        var $loginTrigger = $('.wd-account-btns a.wlrp-popup-open').filter(function () {
            return $(this).attr('href') === href;
        }).first();
        if ($loginTrigger.length) $loginTrigger.get(0).click();
    });

    $panel.find('.menu-item-has-children').each(function (index) {
        var $item = $(this);
        var $submenu = $item.children('.sub-menu');
        var $parentLink = $item.children('a').first();
        var parentText = $parentLink.text().trim();
        var parentHref = $parentLink.attr('href');

        if ($submenu.length) {
            var submenuId = 'wd-mobile-submenu-' + index;
            var $backItem = $('<li class="wd-drilldown-back-item"></li>').append(
                $('<button type="button" class="wd-drilldown-back"><i class="fas fa-chevron-left" aria-hidden="true"></i><span>Retour</span></button>')
            );
            var $heading = $('<li class="wd-drilldown-heading-item"><span>Rubrique</span><strong></strong></li>');
            var $parentItem = $('<li class="wd-drilldown-parent-item"></li>').append(
                $('<a class="wd-drilldown-parent-link"></a>')
                    .attr('href', parentHref)
                    .text('Voir tous les articles')
            );
            $heading.find('strong').text(parentText);
            $submenu
                .attr({ id: submenuId, 'aria-hidden': 'true', 'aria-label': parentText })
                .prepend($parentItem)
                .prepend($heading)
                .prepend($backItem);
            $parentLink.attr({
                'aria-haspopup': 'true',
                'aria-expanded': 'false',
                'aria-controls': submenuId,
                'data-mobile-submenu': submenuId,
            });
            $submenu.detach().appendTo($drilldownStack);
        }
    });

    $menuToggle.off('change.wdMobileMenu').on('change.wdMobileMenu', function () {
        setPanelState(this.checked, !this.checked);
    });

    $menuButton.off('keydown.wdMobileMenu').on('keydown.wdMobileMenu', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            $menuToggle.prop('checked', !$menuToggle.prop('checked')).trigger('change');
        }
    });

    $closeButton.add($overlay).on('click', function () {
        closePanel(true);
    });

    $panel.on('click', '.menu-item-has-children > a', function (event) {
        event.preventDefault();
        var $link = $(this);
        var submenuId = $link.attr('data-mobile-submenu');
        var $submenu = submenuId ? $panel.find('#' + submenuId) : $();
        if ($submenu.length) {
            $link.attr('aria-expanded', 'true');
            $submenu.addClass('wd-drilldown-open').attr('aria-hidden', 'false');
            $panel.addClass('wd-submenu-active');
            window.setTimeout(function () {
                $submenu.find('.wd-drilldown-back').first().trigger('focus');
            }, 220);
        }
    });

    $panel.on('click', '.wd-drilldown-back', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var $submenu = $(this).closest('.sub-menu');
        var $parentLink = $panel.find('[aria-controls="' + $submenu.attr('id') + '"]').first();
        $submenu.removeClass('wd-drilldown-open').attr('aria-hidden', 'true');
        $parentLink.attr('aria-expanded', 'false').trigger('focus');
        if (!$panel.find('.wd-drilldown-open').length) $panel.removeClass('wd-submenu-active');
    });

    $panel.on('click', 'a', function () {
        if (!$(this).parent().hasClass('menu-item-has-children')) closePanel(false);
    });

    $panel.on('keydown', function (event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            var $openSubmenu = $panel.find('.wd-drilldown-open').last();
            if ($openSubmenu.length) {
                $openSubmenu.find('.wd-drilldown-back').first().trigger('click');
            } else {
                closePanel(true);
            }
            return;
        }
        if (event.key !== 'Tab') return;
        var $focusable = $panel.find('a:visible, button:visible, input:visible, [tabindex]:visible').filter('[tabindex!="-1"]');
        if (!$focusable.length) return;
        var first = $focusable.get(0);
        var last = $focusable.get($focusable.length - 1);
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            $(last).trigger('focus');
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            $(first).trigger('focus');
        }
    });

    $(document).off('keydown.wdMobileMenu').on('keydown.wdMobileMenu', function (event) {
        if (event.key !== 'Escape' || !$menuToggle.prop('checked')) return;
        var $openSubmenu = $panel.find('.wd-drilldown-open').last();
        if ($openSubmenu.length) {
            $openSubmenu.find('.wd-drilldown-back').trigger('click');
        } else {
            closePanel(true);
        }
    });

    $(window).off('resize.wdMobileMenu').on('resize.wdMobileMenu', function () {
        if (window.innerWidth > 991 && $menuToggle.prop('checked')) closePanel(false);
    });

    setPanelState($menuToggle.prop('checked'), false);
}

function giveFocusToSearchField() {
    $('.search-submit').on('focus', function() {
        $('.search-field').focus();
    })
}

function initQuantityStepper() {
    // Find all quantity inputs and wrap them with stepper UI
    jQuery(document).ready(function($) {
        // Function to create stepper
        function createStepper($input) {
            // Skip if already wrapped
            if ($input.closest('.qty-stepper').length) return;

            const min = parseInt($input.attr('min')) || 1;
            const max = parseInt($input.attr('max')) || 999;
            const step = parseInt($input.attr('step')) || 1;

            // Create wrapper and buttons
            const $wrapper = $('<div class="qty-stepper"></div>');
            const $minus = $('<button type="button" class="qty-btn qty-minus" aria-label="Decrease quantity">−</button>');
            const $plus = $('<button type="button" class="qty-btn qty-plus" aria-label="Increase quantity">+</button>');

            // Wrap input
            $input.wrap($wrapper);
            $input.before($minus);
            $input.after($plus);

            // Update button states
            function updateButtons() {
                const val = parseInt($input.val()) || min;
                $minus.prop('disabled', val <= min);
                $plus.prop('disabled', val >= max);
            }

            // Minus button click
            $minus.on('click', function(e) {
                e.preventDefault();
                let val = parseInt($input.val()) || min;
                if (val > min) {
                    $input.val(val - step).trigger('change');
                }
                updateButtons();
            });

            // Plus button click
            $plus.on('click', function(e) {
                e.preventDefault();
                let val = parseInt($input.val()) || min;
                if (val < max) {
                    $input.val(val + step).trigger('change');
                }
                updateButtons();
            });

            // Update on manual input
            $input.on('change input', function() {
                updateButtons();
            });

            updateButtons();
        }

        // Initialize on page load
        $('input.qty').each(function() {
            createStepper($(this));
        });

        // Re-initialize after AJAX updates (WooCommerce cart/checkout)
        $(document.body).on('updated_cart_totals updated_checkout', function() {
            $('input.qty').each(function() {
                createStepper($(this));
            });
        });
    });
}

// function activeHeaderBtn() {
//     if (window.location.href.indexOf("categorie-produit/abonnements") != -1) {
//         $('.wd-account-btn-white').addClass('wd-is-active');
//     } else {
//         $('.wd-account-btn-white').removeClass('wd-is-active');
//     }
// }
